import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@core/services/language.service';
// import { LanguageService } from '@core/services/language.service';

@Component({
  selector: 'app-z-users',
  templateUrl: './z-users.component.html',
  styleUrls: ['./z-users.component.scss'],
        encapsulation: ViewEncapsulation.None

})
export class ZUsersComponent implements OnInit {
  public arrCoupons: any[] = [];
 

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
        private language : LanguageService
  ) {} 
  public lang : any

  public currentPage = 1;  
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

 
  public levels: any[] = [];
  public tempData = [];
  // public statistics:any
public statistics: any = {};

  @ViewChild(DatatableComponent) table: DatatableComponent;

   

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
this.getAnalasys();

 // Dummy statistics data
  // this.statistics = {
  //   total_users: 1240,
  //   missed_prayers: 492
  // };

// Force reload once to ensure language and data update correctly
  const reloadFlag = localStorage.getItem('reloadOnce');
  if (!reloadFlag) {
    localStorage.setItem('reloadOnce', 'true');
    window.location.reload(); // reloads the page once
    return;
  } else {
    localStorage.removeItem('reloadOnce');
  }

    this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});

    this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
  }
 


  getLevels() {
    this.apisService.users().subscribe({
      next: (response) => {
        this.levels = response.data;
        console.log(this.levels);
      },
    });
  }
 

getAnalasys() {
  this.apisService.analasys().subscribe({
    next: (response: any) => {
      this.statistics = response.data;
      console.log(this.statistics);
    }
  });
}

 

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  
getHomeStatistics(){
  // this.loading.show()
  this.apisService.users().subscribe({
    next: (res) => {
      this.statistics = res.data
      // this.loading.hide()
    },
    error: (err) => {
      console.log('error in fetching', err)
      // this.loading.hide()
    }
  })
} 

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }
}
